import { Footer, Input } from '@bpinternal/ui-kit-next'
import { useState } from 'react'
import { useUpdateKnowledgeBase } from '~/features/knowledge-bases/hooks/useKnowledgeBase'

type RenameKBDialogProps = {
  workspaceId: string
  botId: string
  kbId: string
  close: () => void
  oldName: string
}

export const RenameKBDialog = ({ close, oldName, kbId, workspaceId, botId }: RenameKBDialogProps) => {
  const [kbName, setKbName] = useState(oldName)

  const { mutate: updateKnowledgeBase, isPending } = useUpdateKnowledgeBase()

  const onConfirm = async () => {
    if (kbName.length > 0) {
      updateKnowledgeBase({ name: kbName, id: kbId, workspaceId, botId }, { onSettled: close })
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-muted-foreground">This is the name you will see in your knowledge base list.</p>
      <Input
        value={kbName}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onConfirm()
          }
        }}
        onChange={(e) => {
          setKbName(e.target.value)
        }}
        placeholder="Knowledge Base name"
      />
      <Footer loading={isPending} onConfirm={onConfirm} disabled={kbName.length === 0} />
    </div>
  )
}
